<template>
    <nav class="benefit-tabs" v-if="programs.length > 1">
        <button
            v-for="program in programs"
            :key="program.id"
            type="button"
            class="benefit-tabs-tab"
            :class="{ 'is-active': program.id === active }"
            @click="select(program.id)"
        >
            {{ t(program.label) }}
        </button>
    </nav>
</template>

<script>
const PROGRAMS = [{ id: "points", label: "dashboard-tabPoints" }];

export default {
    name: "BenefitTabs",
    data() {
        return {
            programs: PROGRAMS,
            active: PROGRAMS[0].id,
        };
    },
    methods: {
        select(id) {
            this.active = id;
            this.$emit("select", id);
        },
    },
};
</script>

<style lang="scss">
.benefit-tabs {
  display: flex;
}

.benefit-tabs-tab {
  flex: 1 1 0;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  min-height: 2.75rem;
  border: none;
  border-bottom: 2px solid #e5e7eb;
  background: transparent;
  color: #9da4ae;
  font-size: clamp(0.875rem, 4vw, 1rem);
  font-weight: 500;
  line-height: 1.3;
  cursor: pointer;
}

.benefit-tabs-tab.is-active {
  border-bottom-color: #2aaa4c;
  color: #2aaa4c;
}
</style>
